module.exports = __webpack_public_path__ + "img/yn.425ed6ca.png";